import * as React from "react";
const SvgLogReport = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 9, r: 7.295, stroke: "#1A1A1A", style: {
  stroke: "#1A1A1A",
  stroke: "color(display-p3 0.1020 0.1020 0.1020)",
  strokeOpacity: 1
}, strokeWidth: 1.41 }), /* @__PURE__ */ React.createElement("path", { d: "M8.99316 6V10.1113", stroke: "#1A1A1A", style: {
  stroke: "#1A1A1A",
  stroke: "color(display-p3 0.1020 0.1020 0.1020)",
  strokeOpacity: 1
}, strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 8.9931, cy: 12.1786, r: 0.4, fill: "white", stroke: "#1A1A1A", style: {
  fill: "white",
  fillOpacity: 1,
  stroke: "#1A1A1A",
  stroke: "color(display-p3 0.1020 0.1020 0.1020)",
  strokeOpacity: 1
}, strokeWidth: 0.666667 }));
export default SvgLogReport;
